var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog center-dialog-no-footer",
      attrs: {
        visible: _vm.visible,
        width: "720px",
        "append-to-body": "",
        "close-on-click-modal": false,
      },
      on: { "update:visible": (val) => _vm.emitUpdateVisible(val) },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [
              _c(
                "MemberUidHeader",
                {
                  attrs: {
                    username: _vm.targetInfo.username,
                    uid: _vm.uid,
                    "vip-level": _vm.targetInfo.vip_level,
                  },
                },
                [
                  _c("span", { staticClass: "dialog-subtitle" }, [
                    _vm._v(_vm._s(_vm.dialogTitle)),
                  ]),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.active
        ? _c("ManageAccountAdjustTab", {
            ref: "adjustRef",
            attrs: {
              uid: _vm.uid,
              "target-info": _vm.targetInfo,
              "member-info": _vm.memberInfo,
              "is-active": _vm.active,
              "reset-key": _vm.resetKey,
            },
            on: { success: _vm.handleSuccess },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }